var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100 d-flex align-items-center" }, [
    _c(
      "div",
      {
        staticClass:
          "mpbtn minus d-inline-block d-md-none mr-1 color-brand-forest",
        on: {
          click: function($event) {
            return _vm.mpminus()
          }
        }
      },
      [_c("i", { staticClass: "fa fa-minus" })]
    ),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.selectedQuantity,
          expression: "selectedQuantity"
        }
      ],
      staticClass: "form-control",
      class: {
        "has-error": !_vm.isValid,
        "has-value": _vm.selectedQuantity > 0
      },
      attrs: { type: "number", name: "quantity", min: "0", max: _vm.inventory },
      domProps: { value: _vm.selectedQuantity },
      on: {
        blur: function($event) {
          return _vm.checkValue()
        },
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.selectedQuantity = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "mpbtn plus d-inline-block d-md-none ml-1 color-brand-forest",
        on: {
          click: function($event) {
            return _vm.mpplus()
          }
        }
      },
      [_c("i", { staticClass: "fa fa-plus" })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }